import { NgModule } from '@angular/core';

import { MaterialModule } from '../../modules/material.module';
import { SharedModule } from '../../modules/shared.module';
import { AddressControlComponent } from './address-control.component';

@NgModule({
  imports: [
    SharedModule,
    MaterialModule
  ],
  declarations: [
    AddressControlComponent
  ],
  exports: [
    AddressControlComponent
  ]
})
export class AddressControlModule {}
